import { useRef } from 'react';

export const useAsyncRefProp = <T>(prop: T) => {
  const propRef = useRef<T>(prop);
  propRef.current = prop;
  return propRef;
};
